var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V3C7 1.896 7.896 1 9 1H31L39 9V37C39 38.104 38.104 39 37 39H9C7.896 39 7 38.104 7 37V31",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H30V4",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.44 31H3.56C2.14688 31 1 30.104 1 29V19C1 17.896 2.14688 17 3.56 17H30.44C31.8531 17 33 17.896 33 19V29C33 30.104 31.8531 31 30.44 31Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64 23.64L5.14 19.9H6.83L7.72 22.09L8.44 19.9H9.93L8.51 24.11L10.09 28H8.41L7.42 25.58L6.55 28H5.07L6.64 23.64ZM11.2465 19.9H13.0365V26.79H14.8965V28H11.2465V19.9ZM18.252 28.12C17.4786 28.12 16.902 27.9167 16.522 27.51C16.1486 27.0967 15.9486 26.4433 15.922 25.55L17.452 25.32C17.4586 25.8333 17.5186 26.2033 17.632 26.43C17.752 26.65 17.9286 26.76 18.162 26.76C18.462 26.76 18.612 26.5633 18.612 26.17C18.612 25.8567 18.5386 25.5867 18.392 25.36C18.252 25.1333 18.0286 24.89 17.722 24.63L17.022 24.02C16.6753 23.7267 16.4053 23.4167 16.212 23.09C16.0253 22.7567 15.932 22.3633 15.932 21.91C15.932 21.23 16.132 20.7067 16.532 20.34C16.9386 19.9733 17.4953 19.79 18.202 19.79C18.9686 19.79 19.4886 20.0133 19.762 20.46C20.042 20.9067 20.192 21.45 20.212 22.09L18.672 22.28C18.6586 21.86 18.6186 21.56 18.552 21.38C18.492 21.1933 18.3553 21.1 18.142 21.1C17.9886 21.1 17.8686 21.1667 17.782 21.3C17.702 21.4267 17.662 21.57 17.662 21.73C17.662 22.0033 17.722 22.2333 17.842 22.42C17.9686 22.6067 18.1686 22.82 18.442 23.06L19.112 23.65C19.512 23.99 19.822 24.35 20.042 24.73C20.262 25.11 20.372 25.56 20.372 26.08C20.372 26.46 20.282 26.8067 20.102 27.12C19.9286 27.4267 19.682 27.67 19.362 27.85C19.042 28.03 18.672 28.12 18.252 28.12ZM22.7005 23.64L21.2005 19.9H22.8905L23.7805 22.09L24.5005 19.9H25.9905L24.5705 24.11L26.1505 28H24.4705L23.4805 25.58L22.6105 28H21.1305L22.7005 23.64Z",
    fill: "#E37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.deff2dbe92c7bb4cc1e3e056810ae9f9.svg";
export { ForwardRef as ReactComponent };